import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../Common/Layout";

/* 🔹 Get all dates between two dates */
const getAllDatesBetween = (start, end) => {
  const dates = [];
  let current = new Date(start);
  const last = new Date(end);

  while (current <= last) {
    dates.push(current.toISOString().split("T")[0]);
    current.setDate(current.getDate() + 1);
  }
  return dates;
};

/* 🔹 Format date like 08-Oct-25 */
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });
};

export default function ANNEXURE({ clientName }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedWarehouse, setSelectedWarehouse] = useState("ALL");
  const [selectedCommodity, setSelectedCommodity] = useState("ALL");
  const [allData, setAllData] = useState([]); // store original processed data
  const [selectedBLVessel, setSelectedBLVessel] = useState("ALL");

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  console.log(clientName);

  useEffect(() => {
    if (!clientName || clientName.trim() === "") {
      setRows([]);
      return;
    }

    fetchData();
  }, [clientName]);

  const fetchData = async () => {
    try {
  //    console.log("Fetching annexure for client:", clientName);
       console.log("CLIENT RAW:", clientName);
console.log("CLIENT LENGTH:", clientName?.length);
console.log(
  "CLIENT CHARS:",
  clientName?.split("").map(c => c.charCodeAt(0))
);
      const token = sessionStorage.getItem("token");
      

      const res = await axios.get(
        `https://irc.zentelex.com/api/kataslip/company/${encodeURIComponent(clientName)}`,
        {
          headers: { Authorization: token ? `Bearer ${token}` : "" },
        },
      );

      console.log("ANNEXURE API data:", res.data);

      const processed = generateStockRegister(res.data.data || []);
      console.log("RAW API DATA", res.data.data);
      console.log("PROCESSED", processed);
      setAllData(processed);
      console.log("SETTING ROWS", processed);
      setRows(processed);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  let filtered = [...allData];

  if (selectedWarehouse !== "ALL") {
    filtered = filtered.filter(
      (r) => r.warehouse === selectedWarehouse
    );
  }
 
  if (selectedCommodity !== "ALL") {
  filtered = filtered.filter(
    (r) => r.commodity === selectedCommodity
  );
}
   
  if (selectedBLVessel !== "ALL") {
  filtered = filtered.filter(
    (r) => r.blVessel === selectedBLVessel
  );
}

  if (startDate) {
    filtered = filtered.filter(
      (r) => r.rawDate >= startDate
    );
  }

  if (endDate) {
    filtered = filtered.filter(
      (r) => r.rawDate <= endDate
    );
  }

//  const peakQty = Math.max(
//    ...filtered.map((r) => Number(r.closingQty || 0)),
//    0
//  );
   
  const peakQty = Math.max(
    ...filtered.map((r) => Number(r.closingQty || 0)),
    0
);  
const displayedPeakStock = Math.max(
  ...rows.map((r) => Number(r.closingQty || 0)),
  0
);
//  filtered = filtered.map((r) => ({
//    ...r,
//    peakStock:
//      Number(r.closingQty) === Number(peakQty)
//        ? peakQty
//        : 0,
//  }));

  filtered = filtered.map((r) => ({
  ...r,
  peakStock:
    Number(r.closingQty) === Number(peakQty)
      ? peakQty
      : 0,
}));

  setRows(filtered);
}, [selectedWarehouse,selectedCommodity, startDate, endDate, allData]);

 const generateStockRegister = (data) => {
  if (!data.length) return [];

  const warehouseGroup = {};

  // 🔹 GROUP BY WAREHOUSE → DATE
  data.forEach((item) => {
    const warehouse = item.warehouse || "Unknown";
    const date = item.dateIn || item.dateOut;
    if (!date) return;

    if (!warehouseGroup[warehouse]) warehouseGroup[warehouse] = {};
    if (!warehouseGroup[warehouse][date]) warehouseGroup[warehouse][date] = [];

    warehouseGroup[warehouse][date].push({
      ...item,
        movement:
        item.entry_type?.toUpperCase() === "INBOUND"
        ? "IN"
        : "OUT",
//      movement: item.dateIn ? "IN" : "OUT",
    });
  });

  const finalRows = [];

  Object.keys(warehouseGroup).forEach((warehouse) => {
    let openingBags = 0;
    let openingQty = 0;

 //   const dates = Object.keys(warehouseGroup[warehouse]).sort();
     const txDates = Object.keys(
  warehouseGroup[warehouse]
).sort();

const firstDate = txDates[0];
const lastDate = new Date();

const dates = getAllDatesBetween(
  firstDate,
  lastDate.toISOString().split("T")[0]
);
     	  
     dates.forEach((dateKey) => {
      let inwardBags = 0,
        inwardQty = 0,
        outwardBags = 0,
        outwardQty = 0;

  //    warehouseGroup[warehouse][dateKey].forEach((item) => {
          const dayData =
          warehouseGroup[warehouse][dateKey] || [];

          dayData.forEach((item) => {
	  if (item.movement === "IN") {
          inwardBags += Number(item.noOfBags || 0);
          inwardQty += Number(item.netWt || 0);
        } else {
          outwardBags += Number(item.noOfBags || 0);
          outwardQty += Number(item.netWt || 0);
        }
      });

      const closingBags = openingBags + inwardBags - outwardBags;
      const closingQty = openingQty + inwardQty - outwardQty;

//      peakStock = Math.max(peakStock, closingQty);

 //     const sample = warehouseGroup[warehouse][dateKey][0];
        
    const sample =
  dayData[0] || {
    companyName:
      finalRows.length > 0
        ? finalRows[finalRows.length - 1].clientName
        : "",
    product:
      finalRows.length > 0
        ? finalRows[finalRows.length - 1].commodity
        : "",
    variety:
      finalRows.length > 0
        ? finalRows[finalRows.length - 1].variety
        : "-",
  };
	     
      finalRows.push({
        rawDate: dateKey, // 🔥 needed for date filter
        date: formatDate(dateKey),
        clientName: sample.companyName,
        warehouse,
        commodity: sample.product,
        variety: sample.variety || "-",
        blVessel: sample.bl_vessel_no || "-",
	openingBags,
        openingQty,
        inwardBags,
        inwardQty,
        outwardBags,
        outwardQty,
        closingBags,
        closingQty,
        peakStock: 0,
      });

      openingBags = closingBags;
      openingQty = closingQty;
    });

});
  return finalRows;
};
  const blVesselOptions = [
  "ALL",
  ...new Set(
    allData
      .map((r) => r.blVessel)
      .filter((v) => v && v !== "-")
  ),
];
  const warehouseOptions = ["ALL", ...new Set(allData.map((r) => r.warehouse))];
  const commodityOptions = ["ALL", ...new Set(allData.map((r) => r.commodity))];

  useEffect(() => {
    if (!rows.length) {
      sessionStorage.setItem(
        "peakStock",
        JSON.stringify({ value: 0, date: "" }),
      );
      return;
    }
   
/* const peakQty = Math.max(
  ...rows.map((r) => Number(r.openingQty || 0)),
  0
);

const peakRow =
  rows.find(
    (r) => Number(r.openingQty) === Number(peakQty)
  ) || {};*/
	  
const peakQty = Math.max(
  ...rows.map((r) => Number(r.closingQty || 0)),
  0
);

const peakRow =
  rows.find(
    (r) => Number(r.closingQty) === Number(peakQty)
  ) || {};

sessionStorage.setItem(
  "peakStock",
  JSON.stringify({
    value: peakQty,
    date: peakRow.date || "",
  })
);

console.log(
  "Peak Stock:",
  peakQty,
  "Date:",
  peakRow.date
);
  }, [rows]);
  return (
    <div className="container-fluid my-4">
      <div className="row mb-3">
        <div className="col-md-3">
          <label className="form-label fw-bold">Warehouse</label>
          <select
            className="form-select"
            value={selectedWarehouse}
            onChange={(e) => setSelectedWarehouse(e.target.value)}
          >
            {warehouseOptions.map((wh, i) => (
              <option key={i} value={wh}>
                {wh}
              </option>
            ))}
          </select>
        </div>
        
	  <div className="col-md-3">
  <label className="form-label fw-bold">Commodity</label>

  <select
    className="form-select"
    value={selectedCommodity}
    onChange={(e) => setSelectedCommodity(e.target.value)}
  >
    {commodityOptions.map((c, i) => (
      <option key={i} value={c}>
        {c}
      </option>
    ))}
  </select>
</div>
	
  <div className="col-md-3">
  <label className="form-label fw-bold">
    BL No / Vessel Name
  </label>

  <select
    className="form-select"
    value={selectedBLVessel}
    onChange={(e) =>
      setSelectedBLVessel(e.target.value)
    }
  >
    {blVesselOptions.map((v, i) => (
      <option key={i} value={v}>
        {v}
      </option>
    ))}
  </select>
</div>

        <div className="col-md-3">
          <label className="form-label fw-bold">Start Date</label>
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <label className="form-label fw-bold">End Date</label>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

 
      </div>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="fw-bold mb-3">ANNEXURE – STOCK REGISTER</h5>

          {loading && <p>Loading...</p>}
          {error && <p className="text-danger">{error}</p>}

          {!loading && !error && (
            <div className="table-responsive">
	      <div className="alert alert-info mb-3">
                 <strong>
                   Peak Stock for Selected Period:
                  </strong>{" "}
		       {Math.max(
                          ...rows.map((r) => Number(r.closingQty || 0)),
                               0
                          ).toFixed(3)} MT
                      </div>
              <table className="table table-bordered table-sm text-center">
                <thead className="table-dark">
                  <tr>
                    <th>Date</th>
                    <th>Client Name</th>
                    <th>Warehouse</th>
                    <th>Commodity</th>
                    <th>Variety</th>
                    <th>Opening Bags</th>
                    <th>Opening Qty (MT)</th>
                    <th>Inward Bags</th>
                    <th>Inward Qty (MT)</th>
                    <th>Outward Bags</th>
                    <th>Outward Qty (MT)</th>
                    <th>Closing Bags</th>
                    <th>Closing Qty (MT)</th>
                    <th>Peak Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr key={i}>
                      <td>{row.date}</td>
                      <td>{row.clientName}</td>
                      <td>{row.warehouse}</td>
                      <td>{row.commodity}</td>
                      <td>{row.variety}</td>
                      <td>{row.openingBags}</td>
                      <td>{row.openingQty.toFixed(3)}</td>
                      <td>{row.inwardBags}</td>
                      <td>{row.inwardQty.toFixed(3)}</td>
                      <td>{row.outwardBags}</td>
                      <td>{row.outwardQty.toFixed(3)}</td>
                      <td>{row.closingBags}</td>
                      <td>{row.closingQty.toFixed(3)}</td>
		       <td className="fw-bold text-success">
                          {row.peakStock > 0
                          ? row.peakStock.toFixed(3)
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

